// src/components/Terms.js

import React from 'react';
import '../styles/Terms.css'; // Crie esse arquivo no próximo passo

function Terms() {
  return (
    <section id="terms-and-services" className="terms-container">
      <div className="section-header">
        <h2 className="section-title">Termos de Serviço e Política de Privacidade</h2>
      </div>

      <div className="terms-content">
        <h3>1. Dados Coletados</h3>
        <p>
          Para o funcionamento do nosso site e aprimoramento da experiência do usuário, coletamos os seguintes dados de forma anônima:
        </p>
        <ul>
          <li>Dados de contato: Ao preencher o formulário na seção "Entre em Contato", você nos fornece seu nome, e-mail e telefone. Esses dados são usados exclusivamente para responder à sua solicitação e iniciar o contato via WhatsApp.</li>
        </ul>

        <h3>2. Finalidade da Coleta</h3>
        <p>
          Os dados coletados têm as seguintes finalidades:
        </p>
        <ul>
          <li>Dados de contato: Permitir que a equipe da PC Perícias e Consultorias responda às suas dúvidas, pedidos de orçamento e outras solicitações.</li>
        </ul>

        <h3>3. Como os Dados são Armazenados e Protegidos</h3>
        <p>
          Todos os dados coletados são tratados com confidencialidade.
        </p>
        <ul>
          <li>Dados de Contato: As informações enviadas pelo formulário são direcionadas para o nosso número de WhatsApp, permanecendo nos registros de mensagens do aplicativo. A transmissão dos dados via URL é segura.</li>
          <li>Dados Anônimos: A contagem de visitas é armazenada de forma anônima e não está vinculada a nenhuma informação pessoal.</li>
        </ul>

        <h3>4. Seus Direitos</h3>
        <p>
          De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem o direito de:
        </p>
        <ul>
          <li>Acesso: Solicitar uma cópia dos seus dados pessoais que temos armazenados.</li>
          <li>Correção: Pedir a correção de dados incorretos ou incompletos.</li>
          <li>Exclusão: Solicitar a exclusão dos seus dados, a qualquer momento.</li>
        </ul>
        <p>
          Para exercer qualquer um desses direitos, entre em contato através do nosso e-mail: contato@periciaseconsultorias.com.br.
        </p>

        <h3>5. Alterações nesta Política</h3>
        <p>
          Podemos atualizar nossa Política de Privacidade periodicamente. Recomendamos que você revise esta página com frequência para se manter informado sobre como protegemos seus dados.
        </p>
      </div>
    </section>
  );
}

export default Terms;